<template>
  <basic-container>
    <div class="factoring-contract-detail">
      <div class="inner-con">
        <div class="project-title">
          {{ basicInfoData.projectName }}
          <span v-if="basicInfoData.contractName" class="contract_name"
            >(主合同:{{ basicInfoData.contractName }})</span
          >
          <span class="audit_status">
            <el-image
              class="icon"
              src="/img/factoring/audit_status_icon.png"
            ></el-image>
            <div :class="['tag', 'tag' + dictContractState]">
              {{ basicInfoData.dictContractStateStr }}
            </div>
          </span>
        </div>
        <!-- <div class="project-status">
          <div class="status-title">审批状态</div>
          <div
            class="status-content"
            :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]"
          >
            {{ basicInfoData.auditStatusStr }}
          </div>
        </div> -->
        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="业务信息" name="first">
            <InfoContainer
              style="margin-top: 20px"
              :infoTitle="InfoContainerConfig['infoTitle']"
              :contentConfig="InfoContainerConfig['infoContent']"
            >
              <template slot="basicInfo">
                <avue-form
                  ref="basicInfo"
                  v-model="basicInfoData"
                  :option="formConfig"
                >
                  <template #name>
                    <!-- 存在绑定ID时不可更改项目 -->
                    <!-- <CommonSelect
                                        bindLabel="name"
                                        bindKey="id"
                                        bindValue="name"
                                        dataUrl="bl/blprojectinfo/page"
                                        methods="get"
                                        dataMethod="params"
                                        searchKey="name"
                                        :disabled="$route.params.id && $route.params.id != ''?true:false"
                                        :bindId="basicInfoData.projectInfoId?basicInfoData.projectInfoId:''"
                                    /> -->
                    <div class="project-name" @click="goProject">
                      {{ basicInfoData.name }}
                    </div>
                  </template>

                  <!-- 债权人和债务人选择 -->
                  <template #sellerCustName>
                    <CommonSelect
                      bindLabel="custName"
                      bindKey="id"
                      :clearable="false"
                      bindValue="custName"
                      dataUrl="bl/blreportstandard/relationCustId"
                      methods="get"
                      dataMethod="params"
                      :initParam="initParam"
                      :disabled="!isEditable"
                      :bindId="sellerCustId ? sellerCustId : ''"
                      @handleChange="setSellerCustId"
                    />
                  </template>

                  <!-- 报价方案 -->
                  <template #rentIdList>
                    <div class="flex_wrp">
                      <CommonSelect
                        searchKey="name"
                        bindLabel="name"
                        bindKey="id"
                        bindValue="id"
                        dataUrl="bl/blcontractrental/page"
                        methods="get"
                        dataMethod="params"
                        innerKey="id"
                        innerKeyName="编号:"
                        :disabled="!isEditable"
                        :bindId="
                          basicInfoData.rentIdList
                            ? basicInfoData.rentIdList
                            : ''
                        "
                        @handleChange="setQuotaSchemeId"
                      />

                      <el-button
                        class="el_button"
                        size="small"
                        type="primary"
                        @click="handleRentalDetail()"
                      >
                        查看详情</el-button
                      >
                    </div>
                  </template>
                  <template #buyerCustId>
                    <CommonSelect
                      selectStyle="true"
                      bindLabel="dictValue"
                      bindKey="dictKey"
                      bindValue="dictValue"
                      dataUrl="/blade-/zd/custom/dict"
                      :disabled="!isEditable"
                      :bindId="
                        basicInfoData.buyerCustId
                          ? basicInfoData.buyerCustId
                          : ''
                      "
                      @handleChange="setBuyerCustId"
                    />
                  </template>
                </avue-form>
              </template>
            </InfoContainer>
            <InfoContainer
              :infoTitle="planInfoContainerConfig['infoTitle']"
              :contentConfig="planInfoContainerConfig['infoContent']"
              class="comment-container comment_container"
            >
              <template slot="planInfo">
                <TableCustom
                  :readOnly="!isEditable"
                  :loading="loading"
                  :tableData="tableData"
                  :tableParams="tableInfoConfig"
                  @handleAdd="handleAdd"
                >
                  <template v-slot:sellerCustName="slotParams">
                    <SelectInput
                      :ref="'sellerCustName' + slotParams.index"
                      bindLabel="custName"
                      bindKey="id"
                      bindValue="custName"
                      dataUrl="bl/blreportstandard/relationCustId"
                      methods="get"
                      dataMethod="params"
                      :initParam="initParam"
                      :disabled="!isEditable"
                      @handleChange="
                        (el, type) =>
                          changeSellerCustId(el, type, slotParams.index)
                      "
                      :bindId="
                        tableData[slotParams.index]['sellerCustId']
                          ? tableData[slotParams.index]['sellerCustId']
                          : ''
                      "
                    />
                  </template>
                </TableCustom>
              </template>
            </InfoContainer>

           

            <!-- 流程公共附件 -->
            <Accessory
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
              :idname="uploadPermissionNameTwo"
              :fileMenuUrlname="uploadPermissionNameOne"
              :projectid="basicInfoData.projectInfoId"
              :dynamicId="id"
              :upload="true"
              :permissionList="permissionList"
              :isPermission="true"
            />

            
             <!-- 流程设计相关组件相关数据存储在workflow.js中 -->
            <!-- 流程设计审批信息表单 -->
            <AuditInfo
              ref="auditInfo"
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="isStartedProcess && auditFormData && auditFormData != {}"
              :formDetailData="auditFormData"
              :isEditable="
                processDetail.process ? processDetail.process.isEditable : false
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />
            <!-- 会签意见区 -->
            <CommentStep
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="commentList.length > 0"
              :commentList="commentList"
              :taskSaveData="taskSaveData"
              :taskNo="
                processDetail.process ? Number(processDetail.process.taskNo) : 0
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />
            <!-- 流程记录  -->
            <CommentTable
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="flowData.length > 0"
              :flowData="flowData"
            />

            <!-- 会签意见区 -->
            <InfoContainer
              v-if="!isStartedProcess"
              class="comment-container"
              style="margin-top: 20px"
              :infoTitle="commentBlockConfig['infoTitle']"
              :contentConfig="commentBlockConfig['infoContent']"
            >
              <template #comment>
                <CommentBlock
                  ref="commentBlock"
                  @fileChange="fileChange"
                  :id="id"
                />
              </template>
            </InfoContainer>
          </el-tab-pane>

          <!-- 物质抵押 -->
          <!-- <el-tab-pane label="抵质押物清单" name="second">
            <LogisticsInventory :readOnly="powerDisabled()" />
          </el-tab-pane> -->
          <!-- 附件列表 -->
          <!-- <el-tab-pane label="附件列表" name="third"> </el-tab-pane> -->

          <!-- 流程图（启动流程后显示） -->
          <el-tab-pane label="流程跟踪" name="fourth" v-if="isStartedProcess">
            <template v-if="activeName == 'fourth'">
              <el-card shadow="never" style="margin-top: 5px">
                <wf-design
                  ref="bpmn"
                  style="height: 500px"
                  :options="bpmnOption"
                ></wf-design>
              </el-card>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <BottomLine
      ref="bottomLine"
      v-if="activeName == 'first'"
      :auditState="basicInfoData.auditStatus"
      :processDetail="processDetail"
      :isStartedProcess="isStartedProcess"
      :buildNew="buildNew"
      @buildNewOne="buildNewOne"
      @startProcess="saveProject(true)"
      @saveTask="saveTask"
      @saveProject="saveProject"
      @flowNext="flowNext"
      @openPrintForm="goPrint"
      @refreshData="refreshData"
    />
    <el-dialog
      :close-on-click-modal="false"
      title="报价方案"
      :visible.sync="bjVisible"
      :modal-append-to-body="false"
      width="85%"
    >
      <QuotaComponent
        :bjId="bjId"
        :readOnly="readOnly"
        @dataInfo="getDetail"
        style="margin-top: 20px"
      />
    </el-dialog>
  </basic-container>
</template>
<script>
import Vue from "vue";
import { contractAddFormConfig, tableInfoConfig } from "./contractConfig.js";
import {
  contractDetail,
  contractAdd,
  getContractName,
  suerveyDetail,
} from "@/api/factoring/factoring";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { mapGetters } from "vuex";
// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessoryFactor";
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommentStep from "@/components/workflowComponents/commentStep/commentStep";
import CommentTable from "@/components/workflowComponents/commentTable/commentTable";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine";
import workFlow from "@/mixins/workFlow";
import TableCustom from "@/components/tableCustom/tableCustom";
import SelectInput from "@/components/commonSelect/selectInput";
import LogisticsInventory from "./component/logisticsInventory.vue";
// 报价方案组件
import QuotaComponent from "../quotaScheme/addEdit";
import util from "@/mixins/util";
import { floatAdd } from "@/util/util";
export default {
  name: "FactoringContractDetail",
  mixins: [workFlow, util],
  data() {
    return {
      id: "",
      sellerCustId: "",
      initParam: {},
      processKey: "process_DzNRj7c7p46kXZSfZMHBBjwJ3tp3TA4n",
      activeName: "first",
      detailFormUrl: "/factoring/contractManage/contractDetail",
      dataReady: false,
      isEditable: true,
      basicInfoData: {
                projectInfoId:''
            },
      isStartedProcess: false,
      formConfig: contractAddFormConfig(),
      InfoContainerConfig: {
        infoTitle: "业务信息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      mortgageConfig: {
        infoTitle: "清单列表",
        infoContent: [
          {
            title: "",
            prop: "mortgageContent",
          },
        ],
      },
      planInfoContainerConfig: {
        infoTitle: "子项目金额",
        infoContent: [
          {
            title: "",
            prop: "planInfo",
          },
        ],
      },
      tableInfoConfig: tableInfoConfig(),
      tableData: [],
      bjVisible: false,
      bjId: -1,
      readOnly: false,
      loading: false,
      disabled: false,
      buildNew:false
    };
  },
  components: {
    InfoContainer,
    Accessory,
    AuditInfo,
    CommentStep,
    CommentTable,
    BottomLine,
    CommonSelect,
    CommentBlock,
    TableCustom,
    LogisticsInventory,
    QuotaComponent,
    SelectInput,
  },
  computed: {
    ...mapGetters(["workFlowData", "userInfo"]),
    powerDisabled() {
      return function () {
        return !(
          (this.userInfo.user_id == this.basicInfoData.managerUser ||
            this.userInfo.user_id == this.basicInfoData.assistUser) &&
          this.basicInfoData.auditStatus == 0
        );
      };
    },
  },
  watch: {
    // "$route.prams.id": {
    //   handler(val) {
    //     this.id = val;
    //     this.queryContractDetail();
    //   },
    // },
  },
  async mounted() {
    if (this.$route.params.id && this.$route.params.id != "0") {
      this.id = this.$route.params.id;
      this.queryContractDetail();
    } else {
      this.getSuerveyDetail();
      this.id = await this.setNewId();
      this.getBasicConfigData();
      
    }
    
  },
  methods: {
    goProject() {
      this.$router.push({
        path: `/factoring/projectManage/projectDetail/${this.basicInfoData.projectInfoId}`,
      });
    },
    buildNewOne() {
      this.saveProject()
    },
    refreshData() {
      this.queryContractDetail();
    },
    async getBasicConfigData() {
      this.processDefinedId = await this.userQueryProcessDefinedId(
        this.processKey
      );
      // 获取当前流程文件上传列表权限 permissionList
      this.permissionList = await this.queryTaskUploadDetail(
        this.processDefinedId,
        "",
        true
      );
      // 设置流程表单路径
      this.queryProcessFormDetail(this.processDefinedId);
    },

    async getSuerveyDetail() {
      let res = await suerveyDetail({
        id: this.$route.query.reportId,
      });
      if (res.data.code == 200) {
        this.basicInfoData = res.data.data;
        this.sellerCustId = this.basicInfoData.sellerCustId;
        this.disabled = this.userInfo.user_id != this.basicInfoData.managerUser;
        this.basicInfoData.auditStatusStr = "待提交";
        this.basicInfoData.auditStatus = 0;
        this.basicInfoData.projectName = `${this.basicInfoData.name}`;
        this.basicInfoData.projectNumber = `${this.basicInfoData.number}`;
        this.basicInfoData.projectType = `${this.basicInfoData.projectType}`;
        this.basicInfoData.formAccountingEntity = `${this.basicInfoData.accountingEntity}`;
        this.basicInfoData.isRevolvingCredit = `${this.basicInfoData.isLoopCredit}`;
        this.basicInfoData.reportId = this.$route.query.reportId;
        delete this.basicInfoData.flowableId;

        this.initParam = {
          reportId: this.basicInfoData.reportId,
        };
      }
    },
    async queryContractDetail() {
      let res = await contractDetail({
        id: this.id,
      });
      if (res.data.code == 200) {
        this.loading = false;
        this.basicInfoData = res.data.data;
        this.tableData = res.data.data.blContractRental;

        this.disabled = this.userInfo.user_id != this.basicInfoData.managerUser;
        // 处理表单数据
        this.basicInfoData.projectType = `${this.basicInfoData.projectType}`;
        this.basicInfoData.poundageChargeType = `${this.basicInfoData.poundageChargeType}`;
        this.basicInfoData.cashDepositChargeType = `${this.basicInfoData.cashDepositChargeType}`;
        this.basicInfoData.cashDepositReturnType = `${this.basicInfoData.cashDepositReturnType}`;
        this.basicInfoData.marginReturnType = `${this.basicInfoData.marginReturnType}`;
        this.basicInfoData.guaranteeMethod = `${this.basicInfoData.guaranteeMethod}`;
        this.basicInfoData.formAccountingEntity = `${this.basicInfoData.formAccountingEntity}`;
        this.basicInfoData.isRevolvingCredit = `${this.basicInfoData.isRevolvingCredit}`;

        this.initParam = {
          reportId: this.basicInfoData.reportId,
        };
        this.sellerCustId = this.basicInfoData.sellerCustId;

        this.$refs.basicInfo.option.column.filter((item) => {
          if (
            item.prop === "formAccountingEntity" ||
            // item.prop === "isRevolvingCredit" ||
            item.prop === "contractMoney" ||
            item.prop === "rentDate" ||
            item.prop === "rentIdList"
          ) {
            item.disabled =
              this.userInfo.user_id != this.basicInfoData.managerUser ||
              this.basicInfoData.auditStatus != 0;
          }
        });

        // 查询流程数据
        this.$store.commit("SET_WORKFLOW_STATE", {
          state: this.basicInfoData.auditStatus,
        });
        if (res.data.data && res.data.data.flowableId) {
          this.isStartedProcess = true;
          // 集成在workFlow.js中
          await this.queryFlowData(res.data.data.flowableId);
        } else {
          // 未启动流程 查询第一个节点的文件上传权限
          this.processDefinedId = await this.userQueryProcessDefinedId(
            this.processKey
          );
          this.permissionList = await this.queryTaskUploadDetail(
            this.processDefinedId,
            "",
            true
          );
          // 设置流程表单路径
          this.queryProcessFormDetail(this.processDefinedId);
        }
        

        // 判断页面是否可编辑（1.流程未提交 2.流程详情中isEditable为true可编辑 3.当前为第一步时）
        let presentFlow = this.flowData[this.flowData.length - 1];
        if (
          this.basicInfoData.auditStatus == 0 ||
          this.processDetail.flow[2].historyActivityId ==
            presentFlow.historyActivityId
        ) {
          this.buildNew = true
          this.columnEditChange(true);
        } else {
          this.columnEditChange(false);
        }
      } else {
        this.loading = false;
        this.$message.error(res.data.message);
      }
    },

    columnEditChange(edit) {
      if (this.userInfo.user_id != this.basicInfoData.managerUser) edit = false;
      this.isEditable = edit;
      this.tableInfoConfig.readonly = !edit;
      this.tableInfoConfig.addBtn = edit;
      this.tableInfoConfig.column.map((item) => {
        if (
          item.prop === "sellerCustName" ||
          item.prop == "buyerCustName" ||
          item.prop === "splitInvestMoney"
        ) {
          item.disabled = !edit;
        }
      });
      this.$refs.basicInfo.option.column.filter((item) => {
        if (
          item.prop === "formAccountingEntity" ||
          // item.prop === "isRevolvingCredit" ||
          item.prop === "contractMoney" ||
          item.prop === "rentDate" ||
          item.prop === "rentIdList"
        ) {
          item.disabled = !edit;
        }
      });
    },

    fileChange(fileList) {
      let self = this;
      if (fileList.length > 0) {
        this.attchmentList = [];
        fileList.map((item) => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link,
          });
        });
      }
    },

    async startProcess() {
      let isTrue = false;
      let tableData = this.tableData;
      if (tableData.length == 0) {
        this.$message.error("请先添加子项目");
        return;
      }
      tableData.map((item) => {
        let judge = Object.values({
          sellerCustId: item.sellerCustId,
          buyerCustName: item.buyerCustName,
          splitInvestMoney: item.splitInvestMoney,
          id: item.id,
        }).includes("");

        if (judge) {
          isTrue = true;
          return;
        }
        // return item.dictOutlayType;
      });
      if (isTrue) {
        this.$message.error("请将子项目填写完整");
        return;
      }

      let redirectInfo = {
        url: this.detailFormUrl,
        id: this.id,
      };
      let processNameRes = await getContractName(this.basicInfoData);
      let params = {
        detailFormUrl: JSON.stringify(redirectInfo),
        processId: this.processDefinedId,
        comment: this.$refs.commentBlock.$data.opinionContent,
        attachmentList: this.attchmentList,
        processInstanceName: processNameRes.data.data.processInstanceName,
      };
      let processInsId = await this.startWorkFlowProcess(params);
      this.basicInfoData.flowableId = processInsId;
      this.submitForm();
    },

    // 保存尽调数据
    async saveTask() {
      let taskId = this.processDetail.process.taskId;
      // 从vuex中获取
      let comment = this.workFlowData.opinionContent;
      // let attachmentList = this.workFlowData.attchmentList

      // 流程表单数据
      let customData = this.$refs.auditInfo.commentDetail;
      let formData = this.$refs.auditInfo.$data.formData;

      let variables = this.dealAuditForm(formData, customData);
      // 保存数据存储在variables中
      variables[`comment_${taskId}`] = comment;
      // variables[`attachment_${taskId}`] = attachmentList

      let saveRes = await this.flowSaveTask(variables);
      // 刷新数据
      this.saveTask = {
        comment: "",
        attachment: [],
      };
      this.queryContractDetail(this.id);
      this.$forceUpdate();
    },

    // 流程流转
    async flowNext(taskInfoList) {
      let passType = await this.validForm();

      if (!passType) {
        return;
      }

      let presentFlow = this.flowData[this.flowData.length - 1];
      if (
        this.processDetail.flow[2].historyActivityId ==
        presentFlow.historyActivityId
      ) {
        this.submitForm();
      }

      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;
      let taskName = this.processDetail.process.taskName;

      // 流程表单数据
      let valid = this.$refs.auditInfo.validData();
      if (valid) {
        let customData = this.$refs.auditInfo.commentDetail;
        let formData = this.$refs.auditInfo.$data.formData;

        let variables = this.dealAuditForm(formData, customData);

        if (taskInfoList) {
          await this.selectPeopleFlowNext(
            taskId,
            taskName,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables,
            JSON.stringify(taskInfoList)
          );
        } else {
          await this.taskFlowNext(
            taskId,
            processInsId,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables
          );
        }
        // 刷新数据
        this.getDetail();
        this.$forceUpdate();
      }
    },

    setSellerCustId(data) {
      this.basicInfoData.sellerCustId = data.id;
      this.basicInfoData.sellerCustName = data.custName;
    },

    async saveProject(startProcess) {
      let passType = await this.validForm();

      if (passType) {
        if (startProcess) {
          this.startProcess();
        } else {
          this.submitForm();
        }
      }
      // let self = this;
      // // 验证数据是否完全
      // this.$refs.basicInfo.validate((valid, done) => {
      //   if (valid) {
      //     let money = 0;
      //     let judge = false;
      //     this.tableData.map((item) => {
      //       if (
      //         item.splitInvestMoney === "" ||
      //         item.splitInvestMoney === undefined
      //       ) {
      //         judge = true;
      //       }
      //       money += Number(item.splitInvestMoney);
      //     });
      //     if (judge) {
      //       this.$message.error("投放金额不能为空");
      //     } else if (money != 0 && money == this.basicInfoData.contractMoney) {
      //       // 校验通过, 提交数据
      //       if (startProcess) {
      //         this.startProcess();
      //       } else {
      //         self.submitForm();
      //       }
      //     } else {
      //       this.$message.error("投放总金额与合同金额不符");
      //     }

      //     done();
      //   }
      // });
    },
    validForm() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.$refs.basicInfo.validate((valid, done) => {
          if (valid) {
            let money = 0;
            let judge = false;
            this.tableData.map((item) => {
              if (
                item.splitInvestMoney === "" ||
                item.splitInvestMoney === undefined
              ) {
                judge = true;
              }
              money =floatAdd(money,Number(item.splitInvestMoney)) ;
            });
            if (judge) {
              this.$message.error("投放金额不能为空");
            } else if (
              money != 0 &&
              money == this.basicInfoData.contractMoney
            ) {
              resolve(true);
            } else {
              this.$message.error("投放总金额与合同金额不符");
            }

            done();
          }
        });
      });
    },

    async submitForm() {
      let blContractRentals = this.tableData.map((item) => {
        return {
          ...item,
        };
      });

      let params = {
        ...this.basicInfoData,
        blContractRentals: blContractRentals,
        id: this.id,
      };

      let res = await contractAdd(params);
      if (res.data.code == 200) {
        // 刷新界面
        this.id = res.data.data.id;
        this.getDetail();
        this.$forceUpdate();
        // this.$router.push({
        //   path: `/factoring/contractManage/contractDetail/${res.data.data.id}`,
        // });
        this.$message({
          message: "修改成功",
          type: "success",
        });
      }
    },

    handleRentalDetail() {
      if (this.basicInfoData.rentIdList) {
        this.readOnly = true;
        this.bjId = this.basicInfoData.rentIdList;
        this.bjVisible = true;
      } else {
        this.$message.error("请先选择报价方案");
      }
    },

    getDetail() {
      this.loading = true;
      this.tableData = [];
      this.queryContractDetail();
    },
    changeSellerCustId(el, type, index) {
      if (el) {
        this.$set(this["tableData"][index], "sellerCustId", el.id);
        this.$set(this["tableData"][index], "sellerCustName", el.custName);
      }
    },
    setQuotaSchemeId(data) {
      this.basicInfoData.rentIdList = data.id;
      this.$refs.basicInfo.clearValidate();
    },
    async handleAdd() {
      let id = await this.setNewId();
      this.$set(this["tableData"][this["tableData"].length - 1], "id", id);
    },
  },
};
</script>
<style lang="scss" scoped>
.contract_name {
  font-size: 14px;
  font-weight: 400;
}

.factoring-contract-detail {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;

  .inner-con {
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;

    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }

    .project-title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .project-status {
      .status-title {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }

      .status-content {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
  }

  .comment-container {
    margin-top: 20px;

    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }

  .comment_container {
    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    /deep/ .el-card__body {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .listTable {
      margin-top: 0px !important;
    }

    /deep/ .el-table {
      border: none;
    }

    /deep/ .el-table th {
      background-color: #fff;
      font-weight: 400;
    }
  }

  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .color_0::before {
    background: #fec03d;
  }

  .color_1::before {
    background: #409eff;
  }

  .color_2::before {
    background: #51d351;
  }

  .color_3::before {
    background: #f56c6c;
  }

  .color_4::before {
    background: #f56c6c;
  }

  /deep/.el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }

  /deep/.el-tabs__item.is-active {
    background: none;
  }

  /deep/.el-tabs__header {
    margin: 0px;
  }

  /deep/ .avue-form__menu--center {
    display: none;
  }
}
.flex_wrp {
  display: flex;
  align-items: center;
  .el_button {
    margin-left: 20px;
  }
}
.audit_status {
  display: flex;
  align-items: center;
  margin-left: 20px;
  .icon {
    width: 18px;
    height: 18px;
  }
  .tag {
    margin-left: 10px;
    font-size: 12px;
        font-weight: 400;
    padding: 2px 5px;
    color: #fff;
    background-color: rgba(255, 198, 0, 1);
  }
  .tag4 {
    background-color: rgba(163, 163, 255, 1);
  }
  .tag4 {
    background-color: rgba(251, 140, 117, 1);
  }
  .tag5 {
    background-color: rgba(26, 209, 163, 1);
  }
}
</style>
